import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, tokenStore } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // AuthCallback exchanges the Google session_id first
    if (window.location.hash?.includes("session_id=")) return;
    if (!tokenStore.get()) {
      setUser(false);
      return;
    }
    api.get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        tokenStore.clear();
        setUser(false);
      });
  }, []);

  const applySession = useCallback((data) => {
    tokenStore.set(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const login = useCallback(async (payload) => applySession((await api.post("/auth/login", payload)).data), [applySession]);
  const register = useCallback(async (payload) => applySession((await api.post("/auth/register", payload)).data), [applySession]);
  const googleLogin = useCallback(
    async (sessionId) => applySession((await api.post("/auth/google", { session_id: sessionId })).data),
    [applySession],
  );

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* session already gone */
    }
    tokenStore.clear();
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, login, register, googleLogin, logout }), [user, login, register, googleLogin, logout]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
